import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { DatePipe } from '@angular/common';
import { AlertService } from '../../../services/alert.service';
import { RegisterType } from 'src/app/static/enums';

@Component({
  selector: 'app-letter-advn',
  templateUrl: './letter-advn.component.html',
  styleUrls: ['./letter-advn.component.scss'],
  providers: [DatePipe]
})
export class LetterADVNComponent implements OnInit {

  @Input() signature_url: string;

  @Input() current_first_transaction_date: string;

  @Input() mount: string='';
  @Input() bank: string='';
  @Input() total: string='';
  @Input() iva: string='';
  @Input() account_number: string='';
  @Input() comission: string='';
  @Input() percent: string='';

  employee: any;
  date:any
  dateText:any
  RegisterType = RegisterType;
  NOMIPAY:RegisterType = RegisterType.NOMIPAY
  PACO:RegisterType = RegisterType.PACO
constructor(public modalController : ModalController,private authService:AuthService,public alertService:AlertService) { 
    this.date = this.alertService.getCurrentDate()
    this.dateText=this.alertService.dateFormatText()
  }

  ngOnInit() {
    this.authService.user().subscribe(
      (data:any)=>{
        this.employee = data.high_employee;
        this.employee.name=data.high_employee.name+" "+data.high_employee.paternal_last_name+" "+data.high_employee.mother_last_name
      }
    );
  }

  closeModal(){
    this.modalController.dismiss();
  }
}
